module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-900.495969a3.ttf";